const INFO = {
	main: {
		title: "Khoi's Portfolio",
		name: "Khoi Vu",
		email: "vu.khoi6111@gmail.com",
		logo: "../logo.jpg",
	},
	socials: {
		instagram: "https://www.instagram.com/chefkhoi.rd/?hl=en",
		github: "https://github.com/ChefKhoiRD",
		linkedin: "https://www.linkedin.com/in/khoi-vu61/",
	},
	homepage: {
		title: "Khoi Vu",
		position: "Full-stack web developer",
		description:
			"I specialize in Full-Stack web development, with a strong focus on front-end technologies. My proficiency lies in crafting robust, scalable, and secure web applications through an array of frameworks and technologies. I thrive on tackling intricate challenges while refining and expanding my skill set. My dedication to producing quality code and adhering to industry standards reflects my commitment to excellence. Continuously seeking fresh challenges, I'm eager to further my development journey.",
	},
	about: {
		title: "I'm Khoi Vu",
		description:
			"As a Full Stack Web Developer, I integrate real-world customer service insights into crafting user-centric web applications. I've honed my skills through a rigorous program in Full Stack Development at Trilogy Coding Bootcamp hosted by the University of Utah. Proficient in React, JavaScript, HTML, CSS, and MERN stack technologies, I prioritize innovation by embracing and mastering the latest tools in the ever-evolving tech landscape. My approach centers on delivering User-centered, intuitive and impactful applications that resonate with customers.",
	},
	homepageProjects: [
		{
			title: "Perch - In progress",
			description:
				"A restaurant management app utilizing the power of AI.",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/perch-site",
		},
		{
			title: "Hearts - In progress",
			description:
				"A full stack web application - A Blackjack game with a twist. My submission to Discord App Pitches 2024",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/hearts-game",
		},
		{
			title: "Pokedex",
			description:
				"An in-browser pokedex that displays a picture of a pokemon, it's pokemon cards, and the pokemon's data",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/PokemonProject",
		},
		{
			title: "Under A Tack",
			description:
			"A cork board that allows users to log in and attach events on sticky notes and post it to the global website.",
			linkText: "View Project",
			link: "https://github.com/Avenix17/Project-3-Under-a-tack",
		},
		{
			title: "Note Taker",
			description:
				"A web application that utilizes express and allows users to save and delete personal notes.",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/note-taker-app",
		},	
		{
			title: "Ecommerce Backend",
			description:
				"A backend project that utilizes MySQL database, Express.js, and Sequelize to enter data into the pre-existing database",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/ecommerce-backend",
		},
	],
	allProjects: [
		{
			title: "Perch - In progress",
			description:
				"A restaurant management app utilizing the power of AI.",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/perch-site",
		},
		{
			title: "Hearts - In progress",
			description:
				"A full stack web application - A Blackjack game with a twist. My submission to Discord App Pitches 2024",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/hearts-game",
		},
		{
			title: "Pokedex",
			description:
				"An in-browser pokedex that displays a picture of a pokemon, it's pokemon cards, and the pokemon's data",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/PokemonProject",
		},
		{
			title: "Under A Tack",
			description:
			"A cork board that allows users to log in and attach events on sticky notes and post it to the global website.",
			linkText: "View Project",
			link: "https://github.com/Avenix17/Project-3-Under-a-tack",
		},
		{
			title: "Note Taker",
			description:
				"A web application that utilizes express and allows users to save and delete personal notes.",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/note-taker-app",
		},	
		{
			title: "Team Generator",
			description:
				"A Node command-line application that takes in information about employees and generates an HTML webpage that displays summaries for each employee",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/team-gen",
		},
		{
			title: "Ecommerce Backend",
			description:
				"A backend project that utilizes MySQL database, Express.js, and Sequelize to enter data into the pre-existing database",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/ecommerce-backend",
		},
		{
			title: "Social Network API",
			description:
				"A backend project utilizing Mongoose and MongoDB to insert data as well as handle API endpoints.",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/social-network-api",
		},
		{
			title: "Text Editor",
			description:
				"A project utilizing HTML, CSS and JavaScript to create a text editor. By clicking a button it allows the user to download the note and retreive the it on a later date.",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/text-editor",
		},
		{
			title: "Employee Tracker",
			description:
				"A MySQL backend that uses the terminal to view or add departments, roles, and employees and saves the data in the database.",
			linkText: "View Project",
			link: "https://github.com/ChefKhoiRD/employee-tracker",
		},
	],
};

export default INFO;
